<template>
<div id="modals-global">
    <modal v-show="modalState.success"
           :container="'modal-container'"
           @close="updateModal('success', false)">
        <template v-slot:header>
            <h3 class="float-left">
                Success
            </h3>
            <button type="button" class="close" aria-label="Close Modal" v-on:click="updateModal('success', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <p v-if="success_message" v-html="success_message"></p>
            <p v-else>
                The action you performed was completed successfully.<br>
                Thanks for using {{ product }}.
            </p>
        </template>
    </modal>
    <modal v-show="modalState.warning"
           :container="'modal-container'"
           @close="updateModal('warning', false)">
        <template v-slot:header>
            <h3 class="float-left">
                Oops. Apologies.
            </h3>
            <button type="button" class="close" aria-label="Close Modal" v-on:click="updateModal('warning', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <code v-html="warning_message" />
        </template>
    </modal>
    <modal v-show="modalState.error"
           :container="'modal-container'"
           @close="updateModal('error', false)">
        <template v-slot:header>
            <h3 class="float-left">
                Oops. Apologies.
            </h3>
            <button type="button" class="close" aria-label="Close Modal" v-on:click="updateModal('error', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <p>There was an error making a request to our server.</p>
            <code>
                {{ error_message }}
            </code>
        </template>
    </modal>
    <modal v-show="modalState.session_expired"
           :container="'modal-container'"
           @close="closeAndRedirect">
        <template v-slot:header>
            <h3 class="float-left">
                Your session has expired.
            </h3>
            <button type="button" class="close" aria-label="Close Modal" v-on:click="closeAndRedirect">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <code v-if="session_expired_message">{{ session_expired_message }}</code>
            <code v-else>
                Your current session has expired. Please relogin and try again.
            </code>
        </template>
        <template v-slot:footer>
            <a class="btn btn-big btn-secondary mx-auto text-white" :href="redirectUrl">
                Go to Login page
            </a>
        </template>
    </modal>
    <modal v-show="modalState.unpaid"
           :container="'modal-container'"
           @close="updateModal('unpaid', false)">
        <template v-slot:header>
            <h3 class="float-left">
                Subscription Feature
            </h3>
            <button type="button" class="close" aria-label="Close Modal" v-on:click="updateModal('unpaid', false)">
                <i class="fas fa-times close-modal"></i>
            </button>
        </template>
        <template v-slot:body>
            <p>
                Unfortunately the requested feature is only available to
                <em>{{ product }} subscribers</em>. If you would like to
                access this feature, get a subscription estimate now.
            </p>
        </template>
        <template v-slot:footer>
            <a class="btn btn-big btn-secondary mx-auto text-white" href="/subscribe">
                Learn more
            </a>
        </template>
    </modal>
    <modal v-show="modalState.unverified"
           :container="'modal-container'">
        <template v-slot:header>
            <h3 class="float-left">
                Oops. Apologies.
            </h3>
        </template>
        <template v-slot:body>
            <p>
                Unfortunately the requested feature is only available to verified account.
            </p>
            <p>
                Our admin will verify your account and when it is done, you will receive the notification mail.
            </p>
        </template>
    </modal>
</div>
</template>

<script>
/* eslint-disable import/extensions */
import '~/assets/js/global.js';
import Modal from '~/components/shared/templates/modal.vue';
import { getBrandingVar } from '~/assets/js/utils/whitelabeling.js';

const appName = getBrandingVar('app_name');
const URL_NON_SANE_TOKEN = '/login';

export default {
    name: 'modals-global',
    components: { Modal },
    props: {
        modalState: {
            error: false,
            success: false,
            unpaid: false,
            session_expired: false,
            warning: false,
            unverified: false,
        },
        error_message: String,
        success_message: String,
        warning_message: String,
        session_expired_message: String,
    },
    data() {
        return {
            product: appName,
        };
    },
    computed: {
        redirectUrl() {
            const requestUrl = `${window.location.pathname}${window.location.search}`;
            return `${URL_NON_SANE_TOKEN}?redirect_url=${requestUrl}`;
        },
    },
    methods: {
        requestContact(method) {
            const self = this;
            if (['phone', 'email'].includes(method)) {
                this.doBackendRequest('POST', '/api/request_contact', () => {
                    self.success_message = "Thank you. We'll be in touch soon.";
                    self.updateModal('unpaid', false);
                },
                JSON.stringify({
                    contact_method: method,
                }),
                undefined);
            }
        },
        updateModal(type, state) {
            this.modalState[type] = state;
            this.$emit('updateModal', {
                key: type,
                state,
            });
        },
        closeAndRedirect() {
            window.location = this.redirectUrl;
        },
    },
};
</script>
